import { makeStyles } from "@material-ui/styles";
// import loginBG from "../../images/loginBG.jpg";

export default makeStyles((theme) => ({
  mainContainer: {
    width: "100%",
    height: "100%",
    [theme.breakpoints.up("md")]: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
    },
  },
  mapContainer: {
    border: "1px solid",
    width: "75%",
    height: "100%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  map: {
    width: "100%",
    height: "100%",
  },
  optionContainer: {
    padding: theme.spacing(1),
    border: "1px solid",
    display: "flex",
    flexDirection: "column",
    width: "25%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  formContainer: {
    width: "100%",
    height: "85%",
    // maxHeight: "74vh",
    overflowY: "auto",
    // flexGrow: 1,
  },
  submitContainer: {
    padding: "10px 5px",
    height: "15%",
  },
  accordionDetails: {
    flexDirection: "column",
  },
  accordionHeading: {
    fontSize: 13,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));
